import React from "react";
import Logo from "../images/LogoBig.png";
import logotxt from "../images/logotxt.png";
import Wave from "react-wavify";

const guidelinesData = {
  "guidelines": [
    {
      "category": "USER GUIDELINES FOR ALGAE GROWTH",
      "steps": [
        "Do Not Dispose of Waste in Water Bodies: Avoid throwing waste into water bodies.",
        "Use Designated Waste Bins: Dispose of waste in designated trash bins.",
        "Educate and Raise Awareness: Educate community members about the harmful effects of garbage disposal.",
        "Participate in Clean-Up Drives: Join or organize community clean-up drives.",
        "Promote Recycling: Encourage recycling practices within the community.",
        "Report Illegal Dumping to Jal-Suraksha: Report instances of illegal dumping to Jal-Suraksha.",
        "Support Anti-Litter Campaigns: Support anti-litter campaigns organized by local groups.",
        "Dispose of Hazardous Waste Properly: Dispose of hazardous materials through designated collection points.",
        "Use Biodegradable Products: Choose biodegradable products whenever possible.",
        "Encourage Responsible Fishing Practices: If applicable, promote responsible fishing practices.",
        "Install Trash Traps: Support the installation of trash traps in water bodies.",
        "Plant Vegetation along Water Banks: Participate in initiatives to plant native vegetation along water banks.",
        "Follow Water Conservation Practices: Contribute to water conservation efforts.",
        "Promote Sustainable Practices: Advocate for sustainable practices in your community.",
        "Lead by Example: Demonstrate responsible waste disposal practices."
      ]
    }
  ]
};

const FixedBottomAnimation = () => (
  <div className="absolute bottom-0 left-0 right-0">
    <Wave
      mask="url(#mask)"
      fill="#49B5F0"
      options={{
        height: 10,
        amplitude: 24,
        speed: 0.3,
        points: 3,
      }}
    >
      <defs>
        <linearGradient id="gradient" gradientTransform="rotate(90)">
          <stop offset="0" stopColor="white" />
          <stop offset="0.5" stopColor="black" />
        </linearGradient>
      </defs>
    </Wave>
  </div>
);

const GuideAlgae = () => {
  return (
    <div className="relative bg-white overflow-y-auto pb-20">
      <div className="w-full text-center">
        <div className="mb-2 mx-auto md:w-[7.5%] md:h-[7.5%] w-[15%] h-[15%] mt-0">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Ministry_of_Jal_Shakti.svg"
            alt=""
          />
        </div>
        <div className="mb-2 mx-auto md:w-[2%] w-[4%] mt-0">
          <img
            src={Logo}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="mb-2 mx-auto md:w-[10%] w-[20%] mt-2">
          <img
            src={logotxt}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="p-6 bg-white text-black rounded border border-gray-800">
          <h1 className="text-3xl font-bold mb-4 text-center border-b border-black pt-2">{guidelinesData.guidelines[0].category}</h1>
          <div className="text-left text-xl">
            <ul className="list-disc list-inside">
              {guidelinesData.guidelines[0].steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ul>
          </div>
          <div className="p-10"></div>
        </div>
      </div>
      <FixedBottomAnimation />
    </div>
  );
};

export default GuideAlgae;
